module.exports = __webpack_public_path__ + "static/38-91ac97d949f43c496fc1aac9c8629f3a.png";